// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G4nS","title":"styles_title__G6rdQ"};